import type { IconData } from '@stacksjs/iconify-core'

export const arrowTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M390.624 150.625L256 16L121.376 150.625l22.628 22.627l95.997-95.998v417.982h32V77.257l95.995 95.995z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowTop
